import type { Translation } from 'primeng/api';

export const primengTranslation: Translation = {
  startsWith: 'Começa com',
  contains: 'Contém',
  notContains: 'Não contém',
  endsWith: 'Termina com',
  equals: 'Igual',
  notEquals: 'Diferente',
  noFilter: 'Sem filtro',
  lt: 'Menor que',
  lte: 'Menor ou igual a',
  gt: 'Maior que',
  gte: 'Maior ou igual a',
  is: 'É',
  isNot: 'Não é',
  before: 'Antes',
  after: 'Depois',
  dateIs: 'Data é',
  dateIsNot: 'Data não é',
  dateBefore: 'Data antes de',
  dateAfter: 'Data depois de',
  clear: 'Limpar',
  apply: 'Aplicar',
  matchAll: 'Corresponder tudo',
  matchAny: 'Corresponde a qualquer',
  addRule: 'Adicionar regra',
  removeRule: 'Remover regra',
  accept: 'Sim',
  reject: 'Não',
  choose: 'Escolher',
  upload: 'Enviar',
  cancel: 'Cancelar',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB'],
  dayNames: [
    'domingo',
    'segunda-feira',
    'terça-feira',
    'quarta-feira',
    'quinta-feira',
    'sexta-feira',
    'sábado'
  ],
  dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
  dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthNames: [
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro'
  ],
  monthNamesShort: [
    'jan',
    'fev',
    'mar',
    'abr',
    'mai',
    'jun',
    'jul',
    'ago',
    'set',
    'out',
    'nov',
    'dez'
  ],
  dateFormat: 'dd/mm/yy',
  firstDayOfWeek: 0,
  today: 'Hoje',
  weekHeader: 'Sm',
  weak: 'Fraca',
  medium: 'Média',
  strong: 'Forte',
  passwordPrompt: 'Insira uma senha',
  emptyMessage: 'Nenhuma opção disponível',
  emptyFilterMessage: 'Nenhum resultado encontrado',
  fileChosenMessage: 'Arquivo selecionado',
  noFileChosenMessage: 'Nenhum arquivo selecionado',
  pending: 'Pendente',
  chooseYear: 'Escolher ano',
  chooseMonth: 'Escolher mês',
  chooseDate: 'Escolher data',
  prevDecade: 'Década anterior',
  nextDecade: 'Próxima década',
  prevYear: 'Ano anterior',
  nextYear: 'Próximo ano',
  prevMonth: 'Mês anterior',
  nextMonth: 'Próximo mês',
  prevHour: 'Hora anterior',
  nextHour: 'Próxima hora',
  prevMinute: 'Minuto anterior',
  nextMinute: 'Próximo minuto',
  prevSecond: 'Segundo anterior',
  nextSecond: 'Próximo segundo',
  am: 'am',
  pm: 'pm',
  searchMessage: '{0} resultados disponíveis',
  selectionMessage: '{0} itens selecionados',
  emptySelectionMessage: 'Nenhum item selecionado',
  emptySearchMessage: 'Nenhum resultado encontrado',
  aria: {
    trueLabel: 'Verdadeiro',
    falseLabel: 'Falso',
    nullLabel: 'Não selecionado',
    star: '1 estrela',
    stars: '{star} estrelas',
    selectAll: 'Selecionar tudo',
    unselectAll: 'Desmarcar tudo',
    close: 'Fechar',
    previous: 'Anterior',
    next: 'Próximo',
    navigation: 'Navegação',
    scrollTop: 'Rolar ao topo',
    moveTop: 'Mover para o topo',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    moveBottom: 'Mover para o fundo',
    moveToTarget: 'Mover para destino',
    moveToSource: 'Mover para origem',
    moveAllToTarget: 'Mover todos para destino',
    moveAllToSource: 'Mover todos para origem',
    pageLabel: '{page}',
    firstPageLabel: 'Primeira página',
    lastPageLabel: 'Última página',
    nextPageLabel: 'Próxima página',
    prevPageLabel: 'Página anterior',
    rowsPerPageLabel: 'Linhas por página',
    previousPageLabel: 'Página anterior',
    jumpToPageDropdownLabel: 'Ir para página',
    jumpToPageInputLabel: 'Entrada de página',
    selectRow: 'Linha selecionada',
    unselectRow: 'Linha desmarcada',
    expandRow: 'Expandir linha',
    collapseRow: 'Recolher linha',
    showFilterMenu: 'Mostrar menu de filtro',
    hideFilterMenu: 'Ocultar menu de filtro',
    filterOperator: 'Operador de filtro',
    filterConstraint: 'Restrição de filtro',
    editRow: 'Editar linha',
    saveEdit: 'Salvar edição',
    cancelEdit: 'Cancelar edição',
    listView: 'Visualização em lista',
    gridView: 'Visualização em grade',
    slide: 'Slide',
    slideNumber: 'Número de slide',
    zoomImage: 'Ampliar imagem',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    rotateRight: 'Girar à direita',
    rotateLeft: 'Girar à esquerda',
    listLabel: 'Lista',
    selectColor: 'Selecionar cor',
    removeLabel: 'Remover',
    browseFiles: 'Procurar arquivos',
    maximizeLabel: 'Maximizar'
  }
};
